<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">Packing Sector Product Priority</h3>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="12" md="5" lg="4" class="pr-md-1 mb-2 mb-md-0">
            <b-form-input
              size="sm"
              type="text"
              placeholder="Packing Sector / Product SKU / Priority Name"
              v-model="search_criteria.keyword"
              @keyup.enter="onSearch"
            />
          </b-col>
          <b-col class="text-left p-md-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>
            <b-button class="btn-action ml-2" size="sm" variant="info" @click="onExport">
              Export
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      />

      <b-table
        responsive
        small
        outlined
        striped
        hover
        sticky-header="650px"
        :items="items"
        :fields="fields"
        :busy="isLoading"
      >
        <template v-slot:cell(product_sku)="data">
          <code>{{ data.item.product_sku }}</code>
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      />
    </b-container>
  </div>
</template>

<script>
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";

const fields = [
  { key: "packing_sector", label: "Packing Sector" },
  { key: "product_sku", label: "Product SKU" },
  { key: "priority", label: "Priority" },
  { key: "priority_name", label: "Priority Name" }
];

export default {
  name: "PackingSectorProductPriority",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  mixins: [apiService, global_function],
  data() {
    return {
      items: [],
      fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      isLoading: false,
      search_criteria: {
        keyword: ""
      }
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.isLoading = true;

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "packing_sector_product_priority_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria
        }
      });

      this.items = response.data.items || [];
      this.total_rows = parseInt(response.data.total_rows || 0);
      this.isLoading = false;
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.currentPage = 1;
      this.table_offset = 0;
      this.fetchList();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.table_offset = (page - 1) * this.TABLE_LIMIT;
      this.fetchList();
    },

    onExport() {
      let loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "packing_sector_product_priority_export.php",
        data: {
          search_criteria: this.search_criteria
        },
        responseType: "blob"
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "packing_sector_product_priority.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        loader.hide();
      });
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/PackingSectorProductPriority.vue